export default __webpack_public_path__ + "static/media/photo.00887ac3.svg";